import { atom, selector } from 'recoil';

export const userState = atom({
  key: 'user',
  default: null,
});

export const isDevSelector = selector({
  key: 'is-dev-selector',
  get: ({ get }) => {
    const user = get(userState);
    return user?.user && user.user.scopes && user.user.scopes.indexOf('dev') >= 0;
  },
});
